import React from 'react'
import clsx from 'clsx'
import {AppView} from '../../schema'
import {useAppDispatch, useAppSelector} from '../../store/hooks'
import {selectAppView, setAppView} from '../../store/slices/appViewSlice'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faHome} from '@fortawesome/free-solid-svg-icons'
import {
  selectSearchParams,
  setSearchParams
} from '../../store/slices/searchParamsSlice'
import {submitSearch} from '../../store/slices/searchSubmittedSlice'

export interface BreadcrumbProps {
  className?: string
}

const Breadcrumb = ({className = ''}: BreadcrumbProps) => {
  const appView = useAppSelector(selectAppView)
  const dispatch = useAppDispatch()
  const searchParams = useAppSelector(selectSearchParams)

  if (appView === AppView.HOME) {
    return
  }

  const handleChoosePropertyClick = () => {
    dispatch(setAppView(AppView.CHOOSE_PROPERTY))
    dispatch(setSearchParams({...searchParams, propertyId: 'all'}))
    dispatch(submitSearch())
  }

  return (
    <div className={clsx('text-xs sm:text-sm breadcrumbs', className)}>
      <ul>
        <li>
          <a
            className="link"
            onClick={() => dispatch(setAppView(AppView.HOME))}
            onKeyDown={(e: React.KeyboardEvent<HTMLAnchorElement>) => {
              if (e.key === 'Enter') {
                dispatch(setAppView(AppView.HOME))
              }
            }}
            tabIndex={0}
            aria-label="Navigate to the search home page."
          >
            <FontAwesomeIcon
              className="sm:hidden"
              icon={faHome}
              title="Search home"
            />
            <span className="hidden sm:block">home</span>
          </a>
        </li>
        {appView === AppView.CHOOSE_PROPERTY && <li>choose property</li>}
        {appView === AppView.CHOOSE_UNIT && (
          <>
            <li>
              <a
                className="link"
                onClick={() => handleChoosePropertyClick()}
                onKeyDown={(e: React.KeyboardEvent<HTMLAnchorElement>) => {
                  if (e.key === 'Enter') {
                    handleChoosePropertyClick()
                  }
                }}
                tabIndex={0}
                aria-label="Navigate to the choose property page."
              >
                choose property
              </a>
            </li>
            <li>choose room</li>
          </>
        )}
        {appView === AppView.CHECKOUT && (
          <>
            <li>
              <a
                className="link"
                onClick={() => handleChoosePropertyClick}
                onKeyDown={(e: React.KeyboardEvent<HTMLAnchorElement>) => {
                  if (e.key === 'Enter') {
                    handleChoosePropertyClick()
                  }
                }}
                tabIndex={0}
                aria-label="Navigate to the choose property page."
              >
                choose property
              </a>
            </li>
            <li>
              <a
                className="link"
                onClick={() => dispatch(setAppView(AppView.CHOOSE_UNIT))}
                onKeyDown={(e: React.KeyboardEvent<HTMLAnchorElement>) => {
                  if (e.key === 'Enter') {
                    dispatch(setAppView(AppView.CHOOSE_UNIT))
                  }
                }}
                tabIndex={0}
                aria-label="Navigate to the choose room page."
              >
                choose room
              </a>
            </li>
            <li>checkout</li>
          </>
        )}
      </ul>
    </div>
  )
}

export default Breadcrumb
